'use client'
import { createContext, useEffect, useState, ReactNode } from 'react'
import Cookies from 'js-cookie'
import { useRouter } from 'next/navigation'
import api from '@/lib/api'
import { useSearchParams } from "next/navigation";
// import { User } from '@/lib/api/type'
// import { getUserInfo } from '@/lib/api/get-user-info'
// import { googleLogin } from '@/lib/api/google-login'
// import { SESSION_COOKIE_NAME } from '@/lib/config/api'

const SESSION_COOKIE_NAME = 'session'

enum UserRole {
    Common = 1,
}
  
enum UserStatus {
    Enable = 1,
    Disable = 2,
}

interface User {
    id: number
    username: string // 后端从Google直接获得。前端直接展示。
    password: string
    display_name: string
    role: UserRole
    status: UserStatus
    email: string
    github_id: string
    wechat_id: string
    telegram_id: string
    verification_code: string
    access_token: string // 暂时不用管。
    quota: number // Token数，不同模型消耗不同，不展示给用户。
    used_quota: number
    amount: number // 余额。单位，美元分。
    request_count: number // 请求次数。
    group: string // 用户所属的组。
    aff_code: string // 邀请码。
    aff_count: number // 邀请人数。
    aff_quota: number // 邀请额度。
    aff_history_quota: number // 邀请额度历史。
    inviter_id: number // 邀请人ID。
    DeletedAt: null | string
  }

export interface ContextProviderValue {
  user: User | null
  handleGoogleLogin: () => void
  logout: () => void
  getInfo: () => Promise<void>
  jumpText: string
}

export interface ContextProviderProps {
  children: ReactNode
}

export const AppContext = createContext({} as ContextProviderValue)


export const AppContextProvider = ({ children }: ContextProviderProps) => {
  const [user, setUser] = useState<User | null>(null)
  const router = useRouter()
  const searchParams = useSearchParams();  /**
   * 处理 Google OAuth 登录
   */
  const handleGoogleLogin = () => {
    const clientId = '7392438826-eobabbu7nhif569o1urgbfngo1vfrbf2.apps.googleusercontent.com'
    const redirectUri = `https://heck.ai/login?google=true`
    const scope = 'email profile'

    if (!clientId || !redirectUri) {
      console.error('Google OAuth 环境变量未正确配置')
      return
    }

    const authUrl = `https://accounts.google.com/o/oauth2/v2/auth?client_id=${clientId}&redirect_uri=${encodeURIComponent(
      redirectUri
    )}&response_type=code&scope=${encodeURIComponent(scope)}`

    window.location.href = authUrl
  }

  /**
   * 处理 Google OAuth 回调
   */

  const [jumpText, setJumpText] = useState('');

  useEffect(() => {
    const previousPath = searchParams.get("from");
    // 跳转提示
    const handleOAuthCallback = async (code: string) => {
      try {
        // /oauth/google/login
        setJumpText('登录跳转中');
        const data = await api.post('/oauth/google/login/code', { code })
        // setUser(userInfo.data)
        typeof window !== "undefined" && localStorage.setItem('userInfo', data.userInfo)
        typeof window !== "undefined" && localStorage.setItem('token', data.tokens.accessToken)
        // window.history.replaceState({}, document.title, window.location.pathname)
        setTimeout(()=> {
          // router.replace('/', { scroll: false })
          // router.back();
          // window.history.go(-2);
          console.log('previousPath----', previousPath)
          setJumpText('');
          router.replace(previousPath || '/')
        }, 0)

        // setTimeout(() => {
        //   const element = document.getElementById('modelsSearch')
        //   element?.scrollIntoView({ behavior: 'smooth' })
        // }, 3000)
      } catch (error) {
        console.error('OAuth callback failed:', error)
      }
    }

    const urlParams = new URLSearchParams(window.location.search)
    const isGoogle = urlParams.get('google') === 'true'
    const code = urlParams.get('code')

    if (isGoogle && code) {
      handleOAuthCallback(code)
    }
  }, [router])

  /**
   * 用户登出
   */
  const handleLogout = () => {
    setUser(null)
    // Cookies.remove(SESSION_COOKIE_NAME, { domain: '.heck.ai' })
    typeof window !== "undefined" && localStorage.removeItem('userInfo')
    // router.push('/login')
  }

  /**
   * 获取用户信息
   */
  const getInfo = async () => {
    console.log('getInfo', Cookies.get(SESSION_COOKIE_NAME))
    // if (!Cookies.get(SESSION_COOKIE_NAME)) return

    try {
      const userInfo = await api.get('/user/self');
      if (userInfo.data) {
        setUser(userInfo.data)
        typeof window !== "undefined" && localStorage.setItem('userInfo', JSON.stringify(userInfo.data))
      } else {
        handleLogout()
      }
    } catch (error) {
      console.error('获取用户信息失败:', error)
      handleLogout()
    }
  }

  useEffect(() => {
    const storedUserInfo = typeof window !== "undefined" && localStorage.getItem('userInfo')

    if (storedUserInfo && storedUserInfo !== 'undefined') {
      try {
        const parsedUser = JSON.parse(storedUserInfo)
        if (parsedUser) {
          setUser(parsedUser)
          return
        }
      } catch (error) {
        console.error('解析用户信息失败:', error)
      }
    }

    // getInfo()
  }, [])

  return (
    <AppContext.Provider
      value={{
        user,
        handleGoogleLogin,
        logout: handleLogout,
        getInfo,
        jumpText,
      }}
    >
      {children}
    </AppContext.Provider>
  )
}